import { apiClient, ApiError } from './apiClient';

export interface OnboardingStatus {
  onboardingCompleted: boolean;
  onboardingCompletedAt: string | null;
}

class OnboardingService {
  async getStatus(): Promise<OnboardingStatus> {
    try {
      return await apiClient.get<OnboardingStatus>('/api/v1/onboarding/status');
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.status === 401) {
          throw new OnboardingError('not_authenticated', 'User is not authenticated');
        }
        throw new OnboardingError('request_failed', err.message);
      }
      throw err;
    }
  }

  async complete(skipped: boolean): Promise<OnboardingStatus> {
    try {
      return await apiClient.post<OnboardingStatus>('/api/v1/onboarding/complete', { skipped });
    } catch (err) {
      if (err instanceof ApiError) {
        throw new OnboardingError('request_failed', err.message);
      }
      throw err;
    }
  }

  async reset(): Promise<OnboardingStatus> {
    try {
      return await apiClient.post<OnboardingStatus>('/api/v1/onboarding/reset');
    } catch (err) {
      if (err instanceof ApiError) {
        throw new OnboardingError('request_failed', err.message);
      }
      throw err;
    }
  }
}

export class OnboardingError extends Error {
  constructor(
    public code: string,
    message: string
  ) {
    super(message);
    this.name = 'OnboardingError';
  }
}

export const onboardingService = new OnboardingService();
export default onboardingService;
